import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface CredentialTypeMetadata {
  key: string;
  category: string;
  key_label: string;
  category_label: string;
  form_options: Record<string, any>;
}

export interface JobCredentialRequirement {
  id: number;
  strictness: string;
  credential_type: {
    key: string;
    category: string;
    key_label: string;
    category_label: string;
    form_options: Record<string, any>;
  };
}

export interface SetRequirementPayload {
  credential_type_key: string;
  strictness: string;
}

@Injectable({ providedIn: 'root' })
export class JobCredentialRequirementsApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.api_url;

  getRequirements(scope: string, scopeId?: number): Observable<JobCredentialRequirement[]> {
    let params = new HttpParams().set('scope_type', scope);
    if (scopeId) {
      params = params.set('scope_id', scopeId.toString());
    }
    return this.http.get<JobCredentialRequirement[]>(
      `${this.baseUrl}api/v1/customer/job-credential-requirements`,
      { params }
    );
  }

  setRequirements(scope: string, credentialTypes: SetRequirementPayload[], scopeId?: number): Observable<JobCredentialRequirement[]> {
    const body: any = {
      scope_type: scope,
      credential_types: credentialTypes
    };
    if (scopeId) {
      body.scope_id = scopeId;
    }
    return this.http.put<JobCredentialRequirement[]>(
      `${this.baseUrl}api/v1/customer/job-credential-requirements`,
      body
    );
  }

  getCredentialTypes(): Observable<CredentialTypeMetadata[]> {
    return this.http.get<CredentialTypeMetadata[]>(
      `${this.baseUrl}api/v1/customer/credential-types`
    );
  }
}
